<template>
    <tab-layout :buttons="more.buttons" :parameters="parameters">
        <!-- TAB TITLE -->
        <template #title>
            {{ $l10n.__('Informations financières') }}
        </template>

        <!-- TAB CONTENT -->
        <template #content>
            <div v-if="isLoading" class="relative mt-3">
                <preloader :display="isLoading" />
            </div>

            <div v-if="financialActivity && financialActivity.length > 0">
                <el-table v-if="!isLoading" :data="financialActivityFormatted">
                    <el-table-column
                        prop="turnover"
                        :label="$t.__('overview.tabs.TabFinancialActivityThird.turnover')"
                    >
                        <template #default="scope">
                            <span :class="scope.row.turnover_trend"></span>
                            <span>{{ $filters.numberFormatCurrency(scope.row.turnover) }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column prop="publication_year" :label="$t.__('common.labels.year')">
                    </el-table-column>
                </el-table>
            </div>
            <div v-else>
                <div v-if="!isLoading" class="placeholder">
                    <p>{{ placeholder }}</p>
                </div>
            </div>
        </template>
    </tab-layout>
</template>

<script>
import OverviewTabMixin from './OverviewTabMixin';
import Preloader from 'vcomponents/utilities/Preloader.vue';
import TabLayout from 'vcomponents/overview/tabs/TabLayout.vue';

export default {
    components: {
        Preloader,
        TabLayout,
    },
    mixins: [OverviewTabMixin],
    data() {
        return {
            isLoading: true,
            financialActivity: [],
            canEdit: false,
        };
    },
    computed: {
        financialActivityFormatted() {
            var financialActivityFormatted = [];

            if (this.financialActivity != undefined && this.financialActivity.length > 0) {
                /* Reverse financialActivity because we working the data upside-down */
                var financialActivity = this.financialActivity.reverse();
                var lastActivity = null;

                for (var i = 0; i < financialActivity.length; i++) {
                    var activity = financialActivity[i];

                    var turnover_trend = '';
                    if (activity.turnover != 0 && lastActivity != null) {
                        if (activity.turnover > lastActivity.turnover) {
                            turnover_trend = 'fa fa-chevron-up fa-green';
                        } else {
                            turnover_trend = 'fa fa-chevron-down fa-red';
                        }
                    }

                    financialActivityFormatted[i] = {
                        publication_year:
                            activity.publication_year != null && activity.publication_year != ''
                                ? activity.publication_year
                                : 'nc.',
                        turnover:
                            activity.turnover != '' && activity.turnover != null
                                ? activity.turnover
                                : 'nc.',
                        turnover_trend: turnover_trend,
                    };

                    lastActivity = activity;
                }
                /* Reverse again for put back in the right place */
                financialActivityFormatted = financialActivityFormatted.reverse();
            }

            return financialActivityFormatted;
        },
        parameters() {
            return [
                {
                    key: 'linkedid',
                    value: this.linkedid,
                },
            ];
        },
        placeholder() {
            return this.$l10n.__('Il n’y a aucune activité financière pour le moment');
        },
    },
    created() {
        this.$ajax.get(
            `/rest/thirds/${this.linkedid}/financial-activity`,
            {},
            (result) => {
                this.financialActivity = Object.values(result.dataFinancial);
                this.canEdit = result.permission;
                this.isLoading = false;
            },
            (error) => {
                Push.error(
                    this.$l10n.__("Une erreur s'est produite lors du chargement des données."),
                    false,
                );
                this.isLoading = false;
            },
        );
    },
};
</script>
